export default __webpack_public_path__ + "static/media/neptune.add692de.svg";